import axios from 'axios';

const ENDPOINT = 'unitwidget';

export default {
  get_process_depending_users: async (sitePath, data) => {
    // data: process_id, permission_id
    const url = `${sitePath}/${ENDPOINT}/get_process_depending_users/?process_id=${data.process_id}&permission_id=${data.permission_id}&centro=${data.centro}`;
    return await axios.get(url, data);
  },

  get_depending_select_choices: async(sitePath, data) => {
    // data: reference_value, params
    //  `process_id=${data.process_id}&permission_id=${data.permission_id}`;
    let params = ''
    let char = '?'
    for (const [key, value] of Object.entries(data)) {
      params += `${char}${key}=${encodeURIComponent(value)}`
      char = '&'      
    }
    const url = `${sitePath}/${ENDPOINT}/get_depending_select_choices/${params}`
    return await axios.get(url, data);
  },

  get_depending_input_value: async(sitePath, data) => {
    let params = ''
    let char = '?'
    for (const [key, value] of Object.entries(data)) {
      params += `${char}${key}=${encodeURIComponent(value)}`
      char = '&'      
    }
    const url = `${sitePath}/${ENDPOINT}/get_depending_input_value/${params}`
    return await axios.get(url, data);
  },

  subindicators: async (explorer_filters) => {
    //TODO: upodate multiprocess
    const site_id = explorer_filters.get_filter_value('site');
    const response = await axios.get(`${site_id}/${ENDPOINT}/subindicators/`);
    return response.data;
  },
}
